import { t } from '@if/core/i18n'

/**
 * @deprecated wrong design pattern
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const translate = (key: any, params: Record<string, string | number> = {}): string => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument, @typescript-eslint/no-explicit-any
  return t(key, { replace: params } as any) as string
}

export default translate
